<template>
  <!-- 考核配置 -->
  <div>
    <div class="tools-box">
      <div class="left-box">{{ baseInfo.name }}</div>
      <div class="right-box">
        <Button type="primary" :disabled="!baseInfo.id"
          @click="$refs.addConfigWeek.open({ ...baseInfo, rankId })">配置考核周期</Button>
        <Button type="primary" :disabled="!baseInfo.id" @click="openConfig">配置考核项</Button>
      </div>
    </div>
    <div class="page-body">
      <Menu ref="menuRef" theme="light" :active-name="rankId" @on-select="getTabelData">
        <MenuItem v-for="bean in rankList" :key="bean.id" :name="bean.id">{{ bean.name }}</MenuItem>
      </Menu>
      <div class="table-box">
        <loading :isShow="listLoading" />
        <Table :columns="columns" :data="tableData">
          <template slot-scope="{ row }" slot="action">
            <!-- <img class="table-btn" src="@static/images/product/drage.png" alt=""> -->
            <span class="table-btn" @click="del(row)">删除</span>
          </template>
        </Table>
      </div>
    </div>

    <div class="tools-box right bottom-box">
      <Button type="primary" @click="$emit('prev')">上一步</Button>
    </div>
    <addConfigWeek ref="addConfigWeek"></addConfigWeek>
    <addConfig ref="addConfig" @success="getTabelData(rankId)"></addConfig>
    <!-- 确认弹窗 -->
    <confirm-Modal ref="confirmModal"></confirm-Modal>
  </div>
</template>

<script>
import { common } from '@/api/mixins';
import addConfig from './addConfig';
import addConfigWeek from './addConfigWeek';
import confirmModal from '@/components/commons/confirmModal'
export default {
  mixins: [common],
  components: { addConfig, addConfigWeek, confirmModal },
  data() {
    return {
      baseInfo: {},
      rankId: "",//当前选择的职级id
      rankList: [],//职级列表
      listLoading: false,
      columns: [
        {
          title: '序号',
          width: 60,
          type: 'index',
          align: 'center'
        },
        {
          title: '考核类型',
          key: 'type',
          width: 80,
          align: 'center',
          render(h, params) {
            return (<span>{params.row.type == '1' ? '晋升' : '维持'}</span>)
          }
        },
        {
          title: '变更职级',
          key: 'newRankName',
          minWidth: 100,
          tooltip:true,
          align: 'center'
        },
        {
          title: '方案名称',
          key: 'caseName',
          minWidth: 100,
          tooltip:true,
          align: 'center'
        },
        {
          title: '考核指标',
          key: 'name',
          minWidth: 140,
          tooltip:true,
          align: 'center'
        },
        {
          title: '考核条件',
          key: 'ruleName',
          minWidth: 140,
          tooltip:true,
          align: 'center'
        },
        {
          title: '操作',
          slot: 'action',
          align: 'center',
          width: 110,
          fixed:'right'
        }
      ],
      tableData: []
    };
  },
  methods: {
    del(bean) {
      this.$refs.confirmModal.open({
        title: "提示",
        content: "确定删除配置项？",
      }).then(() => {
        const ids = this.tableData.filter(item => item.id != bean.id && bean.type == item.type).map(i => i.id)
        let params = {
          baseId: this.baseInfo.id,
          oldRankId: this.rankId,
          newRankId: bean.newRankId,
          type: bean.type,
          commissionSelected: ids,
          id: bean.caseId
        }
        if (params.type == 2) {
          params.type = '1';
        } else if (params.type == 3) {
          params.type = '2';
          delete params.newRankId;
        }

        this.$http({
          url: '/buz/promotionRule/update',
          type: 'POST',
          data: params
        }).then(res => {
          this.$notice.success('删除成功');
          this.getTabelData(this.rankId);
        })
      }).catch(() => {

      });
    },
    openConfig() {
      let params = {
        ...this.baseInfo,
        rankId: this.rankId,
      }

      let commissionSelected = this.tableData.map(i => i.id)
      if (this.tableData.length) {
        if (this.tableData.filter(i => i.type == 1).length) {
          params.type1_id = this.tableData.filter(i => i.type == 1)[0].caseId
        }
        if (this.tableData.filter(i => i.type == 2).length) {
          params.type2_id = this.tableData.filter(i => i.type == 2)[0].caseId
        }

        // params.type1_id = this.tableData.filter(i => i.type == 2)[0].caseId;//维持id
        // params.type2_id = this.tableData.filter(i => i.type == 3)[0].caseId;//晋升id
      }
      console.log(params)
      this.$refs.addConfig.open(params, commissionSelected)
    },
    init(baseInfo) {
      this.baseInfo = baseInfo;
      this.getRankList();
    },
    // 获取职级列表
    getRankList() {
      this.$http({
        url: '/buz/baseRank/read/all',
        type: 'POST',
        data: {}
      }).then(res => {
        this.rankList = res.data;
        if (res.data[0]) {
          this.rankId = res.data[0].id;
          this.$nextTick(() => {
            this.$refs.menuRef.updateActiveName();
          })
          this.getTabelData()
        }
      });
    },
    getTabelData(name) {
      if (name) {
        this.rankId = name;
      }
      if (!this.baseInfo.id || !this.rankId) return;
      Promise.all([this.getPromotionRule('1'), this.getPromotionRule('2')]).then((result) => {
        console.log(result)
        let arr = [];
        result.forEach(a => {
          a.forEach(item => {
            let list = item.baseCommissions.map(i => {
              i.newRankName = item.newRankName;
              i.newRankId = item.newRankId;
              i.type = item.type;
              i.caseId = item.id;
              return i;
            })
            arr.push(...list)
          })

        })
        this.tableData = arr;
        console.log('arr',arr)
      }).catch((error) => {
        console.log(error)
      })
    },
    getPromotionRule(type) {
      return new Promise((resolve, reject) => {
        this.$http({
          url: '/buz/promotionRule/read/list',
          type: 'POST',
          data: {
            baseId: this.baseInfo.id,
            oldRankId: this.rankId,
            pageNo: 1,
            pageSize: 999,
            type: type,//类型 1-晋升 2-维持
          }
        }).then(res => {
          resolve(res.data)
        });
      });
    },
  }
};
</script>

<style lang="scss" scoped>
.page-body {
  display: flex;
}

.ivu-menu {
  min-width: 120px;
  margin-right: 15px;
  // flex: 0 0 240px;
}

.table-btn {
  vertical-align: middle;
}
</style>
